import { Component, OnInit, ViewContainerRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { DynamicComponentService } from "./dynamic.service";

@Component({
    selector: 'dynamic-component',
    template: ''
})
/**
 * Динамическая вставка компонентов.
 * В index.html вставить компонентный якорь <dynamic-component> </dynamic-component>
 * Динамически вствить компонент, можно через сервис dynamic.component.ts
 */
export class DynamicComponent implements OnInit {
    
    constructor(
        private _viewContainer: ViewContainerRef,
        private _componentFactoryResolver: ComponentFactoryResolver
    ) {
        DynamicComponentService.DCinstance = this;
     }

    ngOnInit() { }

    /**
     * Вставка компоненты в контейнер диалогового окна.
     * @argument anyComponent Компонента вставляемая в контейнер.
     */
    insertComponent<T>(anyComponent:{ new(...args : any[]):T }) :ComponentRef<T> {
        let anyComponentFactory =  this._componentFactoryResolver.resolveComponentFactory(anyComponent);
        let anyComponentRef = this._viewContainer.createComponent(anyComponentFactory);
        anyComponentRef.changeDetectorRef.detectChanges();

        return anyComponentRef;
    }
}